(function () {
  var STAGGER_DELAY = 0.8;
  var TOP_TOLERANCE = 5;

  function centerOutOrder(group) {
    var len = group.length;
    if (len <= 1) return group;
    var ordered = [];
    var mid = Math.floor(len / 2);
    ordered.push(group[mid]);
    for (var i = 1; i <= mid; i++) {
      if (mid - i >= 0) ordered.push(group[mid - i]);
      if (mid + i < len) ordered.push(group[mid + i]);
    }
    return ordered;
  }

  function initIntentGallery() {
    var items = Array.from(document.querySelectorAll('.js-intent-gallery-item'));
    if (!items.length || typeof ScrollTrigger === 'undefined') return;

    var rows = [];
    var currentRow = [];
    var currentTop = null;

    items.forEach(function (item) {
      var top = item.getBoundingClientRect().top;
      if (currentTop === null || Math.abs(top - currentTop) > TOP_TOLERANCE) {
        if (currentRow.length) rows.push(currentRow);
        currentRow = [item];
        currentTop = top;
      } else {
        currentRow.push(item);
      }
    });
    if (currentRow.length) rows.push(currentRow);

    rows.forEach(function (row) {
      var ordered = centerOutOrder(row);
      var trigger = row[0];

      ScrollTrigger.create({
        trigger: trigger,
        start: 'top 35%',
        once: true,
        onEnter: function () {
          ordered.forEach(function (item, i) {
            var media = item.querySelector('.intent-gallery__item-media');
            if (!media) return;
            gsap.to(media, {
              opacity: 1,
              duration: 1.6,
              delay: i * STAGGER_DELAY,
              ease: 'power4.inOut',
            });
          });
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntentGallery);
  } else {
    initIntentGallery();
  }
})();
